import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PosCheckout from '../pos-checkout/pos-checkout.vue';
import { PosSession } from '@pos/interfaces/pos-session';
import moment from 'moment';
import { mixins } from 'vue-class-component';
import ClosePosSessionDrawerMethods from '@pos/components/others/pos-checkout-drawer/close-pos-session-drawer-methods';
import ResumePosSessionDrawerMethods from '@pos/components/others/pos-checkout-drawer/resume-pos-session-drawer-methods';
import ContactForm from '@contacts/components/forms/contact-form/contact-form.vue';
import { Contact } from '@contacts/interfaces/contact';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';

@Component({
  name: 'bpc-pos-checkout-drawer',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-pos-checkout': PosCheckout,
    'bpc-contact-form': ContactForm,
  },
})
export default class PosCheckoutDrawer extends mixins(
  ClosePosSessionDrawerMethods,
  ResumePosSessionDrawerMethods,
) {
  $refs: ClosePosSessionDrawerMethods['$refs'] & {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    contactStdForm: InstanceType<typeof ContactForm> & {
      saveEntity(): Promise<BPCGenericApiResponse>;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
      prepareToSave(entity: any): AnyEntity;
    };
  };
  /**
   * SLOTS
   * top-left-buttons
   * top-right-buttons
   */

  public contact: Contact = null;
  public showContactForm: boolean = false;
  public showContactDrawerSection: boolean = false;
  public isSavingContactForm: boolean = false;
  public i = 0;

  mounted() {
    this.$root.$on('contact-more-info', $event => {
      this.onEdit({ item: $event });
    });
    this.$root.$on('update-cash-error-amount', $event => {
      this.onUpdateCashErrorAmount($event);
    });
  }

  destroyed() {
    this.$root.$off('contact-more-info');
    this.$root.$off('update-cash-error-amount');
  }

  onUpdateCashErrorAmount(closingCash) {
    const beginningCash = this.$refs.posSessionForm?.formModel?.beginning_cash || 0;
    const cashSales = this.$refs.posSessionForm?.formModel?.cash_sales || 0;
    const total_cash_movements =
      Number(this.$refs.posSessionForm?.formModel?.total_cash_movements) || 0;
    const cashError = beginningCash + cashSales + total_cash_movements - closingCash;
    this.$set(this.$refs.posSessionForm.formModel, 'cash_error_amount', cashError);
  }

  onClickClose(): void {
    this.$store.commit('pos/closeDrawer');
  }
  get openPosSession(): PosSession {
    return this.$store.getters['pos/openPosSession'];
  }
  get showDrawer(): boolean {
    return this.$store.getters['pos/showDrawer'];
  }
  formatDateTime(date, time): string {
    return moment(`${date} ${time}`).format('DD/MM/YYYY HH:mm');
  }
  get openPosSessionId(): PosSession {
    return this.$store.getters['pos/openPosSessionId'];
  }

  onEdit(e) {
    console.log('clickOnEdit', e);
    this.contact = e.item;
    this.showContactForm = true;
    this.showContactDrawerSection = true;
  }

  getModalTitle() {
    if (this.contact && this.contact.id) {
      return this.$t('global.modals.edit') + ' ' + this.$t('global.models.contact.name');
    } else {
      return this.$t('global.modals.create') + ' ' + this.$t('global.models.contact.name');
    }
  }

  onContactFormSave() {
    this.$refs.contactStdForm.saveEntity();
  }

  onContactFormSaved($event: any = null) {
    this.onContactFormClose();
  }

  onContactFormClose() {
    this.showContactForm = false;
    this.showContactDrawerSection = false;
    this.i++;
    this.isSavingContactForm = false;
  }
  onSavingContactEntity(event) {
    this.isSavingContactForm = event;
  }

  onErrorSavingContact(): void {
    this.isSavingContactForm = false;
  }

  get posExpanded(): boolean {
    return this.$store.getters['pos/posExpanded'];
  }
  get posInSidepane(): boolean {
    return this.$store.getters['pos/posInSidepane'];
  }

  @Watch('showDrawer')
  onCloseDrawer() {
    if (this.showDrawer === false) {
      this.onContactFormClose();
    }
  }
}
